import React from "react";
import { Button } from "react-bootstrap";
import Layout from "./Layout";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { blobURL } from "common/StringUtils";
import { getSchemaMarkup, mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const Ambassador = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("ambassador");
  const navigate = useNavigate();

  const { t } = useTranslation();

  const AmbassadorImage = `${blobURL}/Ambassador.jpg`;
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    mobileScroll();
  }, []);

  const FindUser = () => {
    return (
      <>
        <Helmet>
          {schemaMarkup && (
            <script type="application/ld+json">
              {JSON.stringify(schemaMarkup)}
            </script>
          )}
          <title>{t("Become an ambassador for Invozio")}</title>
          <meta
            name="description"
            content={t(
              "Share your self-employed journey as a Invozio ambassador. Inspire others, be seen on our channels and get paid for your participation. Apply now."
            )}
          />
          <link rel="canonical" href="https://invozio.com/ambassador" />
        </Helmet>

        <div
          className={
            dashboardFooter === false
              ? "network-page ambassdor-js new_ambass new_desgn_insurance new_margin_header"
              : "network-page ambassdor-js new_desgn_insurance new_ambass new_nw amd_respnvs"
          }
        >
          <div className="home-page">
            <section className="insurns_wrap px-4 ambassador inner">
              <div className="container p-0">
                <div className="row align-items-center">
                  <div
                    className={
                      dashboardFooter === false ? "col-md-6" : "col-lg-6"
                    }
                  >
                    <div className="security_text">
                      <h1 className={`security_about text-uppercase mb-0`}>
                        {t("Become an ambassador")}
                      </h1>
                      <h3 className={`fnt_family ${!user && "color_change"}`}>
                        {t(
                          "Be a part of Invozio and share your journey as a self-employed freelancer!"
                        )}
                      </h3>

                      {!user && (
                        <Button
                          className="mt-3 new_theme_btn "
                          onClick={() =>
                            navigate(
                              language === LOCALES.EN_US
                                ? `/emailregister?lang=${LOCALES.EN_US}`
                                : `/e-postregister?lang=${LOCALES.SV_SE}`
                            )
                          }
                        >
                          {t("Create Free Account")}
                        </Button>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      dashboardFooter === false ? "col-md-6" : "col-lg-6"
                    }
                  >
                    <div className="text-right">
                      <div className="image_wrap ml-3">
                        <img
                          src={AmbassadorImage}
                          alt="ambassador-banner"
                          className="image-fluid"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className=" newdesign pt-3">
              <div className="without_background">
                <p className="top_section_para">
                  {t(
                    "Since the start of Invozio, many self-employed individuals have been invoicing without having their own business. Initially, it was primarily freelancers in traditional freelance professions, but today people from all kinds of industries, both in Sweden and abroad, use our platform. Self-employed individuals are at the heart of our business, which is why we want to highlight their stories even more. Perhaps it’s you and your journey as a freelancer that will be our next feature?"
                  )}
                </p>
                <p className="top_section_para mt-2">
                  {t(
                    "As an influencer for Invozio, you will share your experience as a self-employed individual through our channels, thereby inspiring others to take the leap or develop as freelancers."
                  )}
                </p>
                <p className="top_section_para mt-2">
                  <strong className="heading_edit">
                    {t("We are looking for those who:")}
                  </strong>
                  <br></br>
                  {t("• Have been or are currently self-employed.")}
                  <br></br>
                  {t(
                    "• Want to inform and inspire others based on their experiences in self-employment."
                  )}
                  <br></br>
                  {t(
                    "• Would like to be interviewed and have their journey documented in text, photos, and videos. Your material will later be used in Invozio’s channels."
                  )}
                </p>
                <p className="top_section_para mt-2">
                  <strong className="heading_edit">
                    {t("You will receive:")}
                  </strong>
                  <br></br>
                  {t(
                    "•	The opportunity to be seen and share experiences and knowledge in Invozio’s channels."
                  )}
                  <br></br>
                  {t(
                    "•	Material in the form of photos and videos that you can use in your future work."
                  )}
                  <br></br>
                  {t("•	Compensation for your participation.")}
                </p>
                <p className="top_section_para mt-2">
                  <strong className="heading_edit">
                    {t("Register now through our partner programs:")}
                  </strong>
                  <br></br>
                  <strong className="text-dark">
                    {t("•	TradeDoubler for Publishers: ")}
                  </strong>
                  {t(
                    "If you're a publisher who wants to collaborate with Invozio by sharing your journey and experiences, register via TradeDoubler to receive compensation and take advantage of the benefits."
                  )}
                  <Link
                    target="_blank"
                    style={{ color: "#5d47b6", textDecoration: "underline" }}
                    to="https://directory.tradedoubler.com/en/programs/344244-Invozio"
                  >
                    {t("Register Here")}{" "}
                  </Link>
                  <br></br>
                  <strong className="text-dark">
                    {t("•	Metapic for Influencers: ")}
                  </strong>
                  {t(
                    "If you're an influencer who wants to inspire others by sharing your journey as a freelancer, register via Metapic to receive compensation and collaborate with us."
                  )}
                  <Link
                    target="_blank"
                    style={{ color: "#5d47b6", textDecoration: "underline" }}
                    to="https://app.metapic.com/signup-description?utm_campaign=invozio&utm_source=website"
                  >
                    {t("Register Here")}{" "}
                  </Link>
                </p>
                <br></br>
                {t(
                  "We look forward to hearing from you and sharing your unique journey as a freelancer!"
                )}
              </div>
            </section>

            <section className="new_ambassador_css pb-0">
              <div
                className="block-threecolumn-cards acf_block_contact_form bgcolor-lightgrey bg-info mt-4"
                style={{ background: "#c4c4c4" }}
              >
                <div className="new_colrs">
                  <div className="row pb-0 justify-content-center">
                    <div
                      className={
                        dashboardFooter === false
                          ? "col-md-8 m-auto top-section"
                          : "col-lg-8 m-auto top-section"
                      }
                    ></div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {user ? (
        <Layout className="my-customers-table" showSidebar bgcolor>
          {FindUser()}
        </Layout>
      ) : (
        <Layout
          className="p-0 my-customers-table"
          dashboardFooter={dashboardFooter}
        >
          {FindUser()}
        </Layout>
      )}
    </>
  );
};

export default Ambassador;
